import './App.css'
import CalculatorQuoteGenerator from './CalculatorQuoteGenerator/CalculatorQuoteGenerator'
import { createTheme, CssBaseline } from '@mui/material'
import { ThemeProvider } from '@emotion/react'

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '14px',
          },
        },
      },
    },
  })

  return (
    <div className='App'>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <CalculatorQuoteGenerator />
      </ThemeProvider>
    </div>
  )
}

export default App
